module.exports = __webpack_public_path__ + "img/project-30.18eca403.png";